class HHContactForm extends HTMLElement {
  constructor() {
    super()
    this.onSubmit = this.onSubmit.bind(this)
  }

  connectedCallback() {
    this.addEventListener("submit", this.onSubmit)
    this.disableRecaptcha()
  }

  disconnectedCallback() {
    this.removeEventListener("submit", this.onSubmit)
  }

  onSubmit(event) {
    const form = event.target
    if (form.tagName !== "FORM") return

    event.preventDefault()
    event.stopImmediatePropagation()

    const requiredFields = form.querySelectorAll(".js-field.required")
    let formValid = true

    this.clearForm(form)

    requiredFields.forEach((field) => {
      let fieldValid = true
      const input =
        field.querySelector("input") || field.querySelector("textarea")
      if (!input) return false
      const inputType = input.getAttribute("type")

      if (!input.value) {
        field.querySelector(".js-error__required")?.classList.remove("hidden")
        formValid = false
        fieldValid = false
      }

      if (inputType == "email" && !this.validEmailAddress(input.value)) {
        field.querySelector(".js-error__valid")?.classList.remove("hidden")
        formValid = false
        fieldValid = false
      }

      if (!fieldValid) {
        field.classList.add("form-wrapper__with-errors")
      }
    })

    if (!formValid) {
      form.querySelector(".js-form-errors")?.classList.remove("hidden")
    } else {
      this.submitForm(form)
    }
  }

  async submitForm(form) {
    const submitBtn = form.querySelector('[type="submit"]')
    if (submitBtn) submitBtn.setAttribute("disabled", true)

    try {
      const formData = new FormData(form)

      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
      })

      if (response.ok) {
        this.handleSuccess(form)
      } else {
        console.error("Form submission failed")
      }
    } catch (error) {
      console.error("Error submitting form:", error)
    } finally {
      if (submitBtn) submitBtn.removeAttribute("disabled")
    }
  }

  handleSuccess(form) {
    form.querySelector(".contact-input__action")?.classList.add("hidden")
    form.querySelectorAll(".contact-input__group").forEach((group) => {
      group.classList.add("hidden")
    })

    const successMsg = form.querySelector(".js-form-success")
    if (successMsg) {
      successMsg.classList.remove("hidden")
    } else {
      form.innerHTML +=
        '<div class="success-message">Thanks for contacting us. We\'ll get back to you as soon as possible.</div>'
    }
  }

  disableRecaptcha() {
    const forms = this.querySelectorAll("form")
    forms.forEach((form) => {
      // Strip initial attribute
      if (form.hasAttribute("onsubmit")) form.removeAttribute("onsubmit")
    })

    var observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "onsubmit"
        ) {
          mutation.target.removeAttribute("onsubmit")
        }
      })
    })

    observer.observe(this, {
      attributes: true,
      subtree: true,
      attributeFilter: ["onsubmit"],
    })
  }

  validEmailAddress(value) {
    return value.match(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    )
  }

  clearForm(form) {
    form
      .querySelectorAll(
        ".js-form-errors, .js-error__valid, .js-error__required"
      )
      .forEach((element) => {
        element.classList.add("hidden")
      })

    form.querySelectorAll(".js-field").forEach((element) => {
      element.classList.remove("form-wrapper__with-errors")
    })
  }
}

customElements.define("hh-contact-form", HHContactForm)
